import React from 'react';
export function LinkIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M1 10a4 4 0 014-4h2v2H5a2 2 0 00-2 2v4a2 2 0 002 2h8v2H5a4 4 0 01-4-4v-4zm22 4a4 4 0 01-4 4h-2v-2h2a2 2 0 002-2v-4a2 2 0 00-2-2h-8V6h8a4 4 0 014 4v4z"
  }), React.createElement("path", {
    d: "M7 11a1 1 0 100 2h10a1 1 0 100-2H7z"
  }));
}